import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { projectMembersService } from '../api/projectMembers.service';
import { PROJECT_KEYS } from './queryKeys';
import type { AddProjectMemberPayload } from '../types';

export function useAddProjectMember(projectId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const { toast } = useToast();
  const { t } = useTranslation('tasks');

  return useMutation({
    mutationFn: (payload: AddProjectMemberPayload) => projectMembersService.add(projectId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECT_KEYS.members(orgId ?? '', projectId),
      });
      toast.success({ title: t('header.addMember.successToast') });
    },
  });
}
